import { render, staticRenderFns } from "./CompanySeal.vue?vue&type=template&id=38b97abc&scoped=true"
import script from "./CompanySeal.vue?vue&type=script&lang=js"
export * from "./CompanySeal.vue?vue&type=script&lang=js"
import style0 from "./CompanySeal.vue?vue&type=style&index=0&id=38b97abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b97abc",
  null
  
)

export default component.exports